import api from '@/api';

export type NotificationType =
  | 'task_check_in'
  | 'task_needs_attention'
  | 'task_team_comment'
  | 'task_assigned'
  | 'share_invite'
  | 'assistant_reply'
  | 'system'
  | 'team_thread_message'
  | 'team_thread_mention';

export type AppNotification = {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  read?: boolean;
  readAt?: number;
  createdAt: number;
  action: { route: string; query?: Record<string, string> };
  entityRefs?: Record<string, string | undefined>;
};

export async function fetchNotifications(params?: {
  limit?: number;
  cursor?: string;
}): Promise<{
  notifications: AppNotification[];
  unreadCount: number;
  nextCursor?: string;
}> {
  const response = await api.get<{
    status: string;
    notifications?: AppNotification[];
    unreadCount?: number;
    nextCursor?: string;
  }>('/notifications', { params });
  if (response.data?.status !== 'success') {
    return { notifications: [], unreadCount: 0 };
  }
  return {
    notifications: response.data.notifications ?? [],
    unreadCount: response.data.unreadCount ?? 0,
    nextCursor: response.data.nextCursor,
  };
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.patch('/notifications/read-all');
}

export async function dismissNotification(id: string): Promise<void> {
  await api.post(`/notifications/${id}/dismiss`);
}
